import React, { useState, Fragment, useEffect } from "react";
import { styled } from "baseui";
import { useHistory, useParams } from "react-router-dom";
import { Navigation } from "baseui/side-navigation";
import useRouteParams from "../../hooks/useRouteParams";
const StyledUl = styled("ul", (props) => ({
  paddingLeft: "5px",
  margin: "5px",
  height: "100%",
}));

export default function ListSidebarView({ items, depthStep, depth, expanded }) {
  const history = useHistory();
  const { access } = useParams();
  const [activeItemId, setActiveItemId] = useState(access);
  return (
    <div>
      <StyledUl>
        <Navigation
          items={items}
          activeItemId={activeItemId}
          onChange={({ event, item }) => {
            event.preventDefault();
            setActiveItemId(item.itemId);
            history.push({
              pathname: item.itemId,
              search: history.location.search,
            });
          }}
          mapItem={(item) => ({ title: item.title, itemId: item.itemId })}
          overrides={{
            NavLink: {
              style: ({ $theme }) => ({
                textDecoration: "none!important",
              }),
            },
            NavItem: {
              // component: NavItem,
              style: ({ $active, $theme }) => {
                if (!$active)
                  return {
                    ":hover": {
                      color: $theme.colors.accent,
                    },
                  };
                return {
                  backgroundColor: $theme.colors.accent,
                  borderLeftColor: $theme.colors.accent,
                  color: $theme.colors.mono900,
                  ":hover": {
                    color: $theme.colors.accent400,
                  },
                };
              },
            },
          }}
        />
      </StyledUl>
    </div>
  );
}
